/**
 * GeChiUI dependencies
 */
import { Path, SVG } from '@gechiui/primitives';

const separator = (
	<SVG viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
		<Path d="M20.2 7v4H3.8V7H2.2v9h1.6v-3.5h16.4V16h1.6V7z" />
	</SVG>
);

export default separator;
